import styles from '../../ChallengeSettings/ChallengeSettings.module.scss';
import {Snackbar, TextField} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {getChallengeSettings, setChallengeSettings} from '../../../../api/settings';
import { settingsList } from '../../../../const/challenge-setttings-list';
import Button from '@mui/material/Button';
import MuiAlert, {AlertColor} from '@mui/material/Alert';

const EnergyManagementComponent = () => {
  const [settings, setSettings] = useState<any>(settingsList);
  const [isCanSubmit, setIsCanSubmit] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState<{isOpen: boolean, alertType: AlertColor, message: string}>({
    isOpen: false,
    alertType: 'success',
    message: ''
  });
  
  useEffect(() => {
    (async () => {
      const currentSettingsList = await getChallengeSettings();
      if (currentSettingsList.length > 0) {
        const updatedSettingsList = settings.map((item: any) => {
          const settingsItem = currentSettingsList.find((setting: any) => setting.key === item.key);
          
          if (settingsItem) {
            return {
              ...item,
              key: settingsItem.key,
              data: { ...item.data, ...settingsItem.data },
              id: settingsItem.id
            }
          }
          return item;
        });
        
        setSettings(updatedSettingsList);
        handleValidateForm(updatedSettingsList);
      }
    })()
  }, []);
  
  const handleValidateForm = (newSettingsList: any) => {
    const validValues = newSettingsList.map((item: any) => {
      return (Number(item.data.value) > 0 && item.data.energyPrice !== '' && Number(item.data.energyPrice) >= 0)
        || Number(item.data.minutesToAddOneEnergy) > 0;
    });
    
    const isInvalidValue = validValues.includes(false);
    setIsCanSubmit(!isInvalidValue);
  };
  
  const handleChangeCoefficients = (
    { newCoefficients, coefficientsId}: { newCoefficients: number; coefficientsId: string }
  ) => {
    const newSettingsList = settings.map((item: any) => {
      if (item.key === 'ENERGY_ACCRUALS') {
        return {...item, data: {minutesToAddOneEnergy: newCoefficients.toString()}}
      }
      
      if (item.key === coefficientsId) {
        return {...item, data: {...item.data, value: newCoefficients.toString()}}
      }
      
      return item;
    })
    
    setSettings(newSettingsList);
    handleValidateForm(newSettingsList);
  };
  
  const handleSave = async () => {
    try {
      await setChallengeSettings(settings);
      setOpenSnackbar({ isOpen: true, message: 'Energy refill time successfully saved', alertType: "success"});
    } catch (e) {
      setOpenSnackbar({
        isOpen: true,
        message: 'Something went wrong, energy refill time was not saved, please try again later',
        alertType: "success"
      });
    }
  };
  
  return (
    <div>
      {settings.map((item: any, index: number) => {
        if (item.key !== 'ENERGY_ACCRUALS') return null;
        
        return (
          <div className={styles.coefficientsItem} key={index.toString()}>
            <span className={styles.challengeName}>{item.challengeName}</span>
            <TextField
              error={!(Number(item.data.minutesToAddOneEnergy) > 0)}
              id={item.id}
              label={item.label}
              variant="outlined"
              value={item.data.minutesToAddOneEnergy}
              type="number"
              className={styles.coefficientsInput}
              style={{ marginLeft: 0 }}
              onChange={(e) =>
                handleChangeCoefficients({ newCoefficients: Number(e.target.value), coefficientsId: item.key})
              }
              helperText={!(Number(item.data.minutesToAddOneEnergy) > 0) ? "Must be a number greater than 0" : " "}
            />
          </div>
        )
      })}
      <div className="mt-10">
        <Button onClick={handleSave} className="!py-3 !px-10" variant="contained" disabled={!isCanSubmit}>
          Save
        </Button>
      </div>
      <Snackbar
        open={openSnackbar.isOpen}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar({...openSnackbar, isOpen: false})}
      >
        <MuiAlert
          onClose={() => setOpenSnackbar({...openSnackbar, isOpen: false})}
          severity={openSnackbar.alertType}
          sx={{ width: '100%' }}
        >
          {openSnackbar.message}
        </MuiAlert>
      </Snackbar>
    </div>
  )
}

export default EnergyManagementComponent;